import { BusinessUboAddressResp } from 'types/api/response/business-ubo-address-resp'
import { BusinessAddressDto } from 'types/dtos/business-address'

import { api } from './api'

export const validateBusinessUboAddress = (business_ubo_address: BusinessAddressDto) =>
  api.post<BusinessUboAddressResp>('/user_addresses/validate_business_ubo_address', {
    business_ubo_address,
  })
